import { render } from "./customerManageList.vue?vue&type=template&id=7c9770cf&scoped=true"
import script from "./customerManageList.vue?vue&type=script&lang=js"
export * from "./customerManageList.vue?vue&type=script&lang=js"

import "./customerManageList.vue?vue&type=style&index=0&id=7c9770cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9770cf"]])

export default __exports__